export default __webpack_public_path__ + "static/media/_calculator_beroas_dark.839b37b3.svg";